import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-remove",
  "use": "tamr-icon-remove-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"tamr-icon-remove\"><path d=\"M17.4,16L30.7,2.7a1,1,0,0,0-1.4-1.4L16,14.6,2.7,1.3A1,1,0,0,0,1.3,2.7L14.6,16,1.3,29.3a1,1,0,1,0,1.4,1.4L16,17.4,29.3,30.7a1,1,0,0,0,1.4-1.4Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol